export enum ContactTypes {
  CONTACTS_ALL = 'all'
}

export enum ContactTypeId {
  CONTACTS_ALL = 42
}

export enum ContactPersonTypeId {
  NATURAL = '0',
  LEGAL = '1'
}

export enum ContactLegalPersonTypeId {
  AGENCY = '1',
  INSURANCE = '2',
  COMPANY = '3',
  AAPP = '4'
}

export interface ContactsState {
  contacts: any[] | null
  contactTypeSelected: ContactTypes | null
  contactAccounts: ContactAccount[]
}

export const contactsMutationTypes = {
  FETCH_CONTACTS: 'FETCH_CONTACTS',
  RESET_CONTACTS: 'RESET_CONTACTS',
  CONTACT_TYPE_SELECTED: 'CONTACT_TYPE_SELECTED',
  SAVE_SELECTED_CONTACT_PERSON_TYPE: 'SAVE_SELECTED_CONTACT_PERSON_TYPE',
  FETCH_CONTACT_ACCOUNTS: 'FETCH_CONTACT_ACCOUNTS',
  RESET_CONTACT_ACCOUNTS: 'RESET_CONTACT_ACCOUNTS'
}

export interface ContactItem {
  id: string
  name: string
  personTypeId: ContactPersonTypeId
}

export interface ContactAccount {
  id?: string | number
  accountTypeId: string | number
  [key: string]: any
}
